import { useEffect, useRef } from "react";

import "./Services.css";

import SectionHeader from "../_components/section-header/SectionHeader";
import SmallCaption from "../_components/small-caption/SmallCaption";
import ServiceDescription from "./service-description/ServiceDescription";
import FAQ from "../faq/FAQ";

import serviceDescriptions from "./serviceDescriptions";
import createAnimation from "../_utils/createAnimation";

const Services = () => {
  const ref = useRef(null);

  useEffect(() => createAnimation(ref), []);
  const services = serviceDescriptions.map(
    ({ id, name, description, image, link }, i) => {
      return (
        <ServiceDescription
          id={id}
          key={id}
          name={name}
          description={description}
          image={image}
          link={link}
          i={i}
        />
      );
    }
  );

  return (
    <main className="Services">
      <section className="Services-header" ref={ref}>
        <SmallCaption text="CHOOSE YOUR IDEAL SETTING" />
        <SectionHeader text="Individual, Couple, or Group" />
      </section>
      {services}
      <FAQ />
    </main>
  );
};

export default Services;
